import styled from "styled-components";
import { ChangeEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Text from "@/components/Text";
import {
  InputGroup,
  ResetButton,
  ResetHolder,
  StyledInput,
  Wrapper,
} from "@/pages/AssignTopics/components/Filter";
import { selectTeamSettings } from "@/selectors";
import { Dispatch, RootState } from "@/utils/store";
import useDebounce from "@/hooks/useDebounce";
import useDidUpdate from "@/hooks/useDidUpdate";
import { TeamSettings } from "@/types/resources";

const StyledText = styled(Text)`
  font-size: 11px;
`;

const DistributionVideoFilter = () => {
  const dispatch = useDispatch<Dispatch>();

  const { teamId } = useParams();

  const teamSettings = useSelector((rootState: RootState) =>
    selectTeamSettings(rootState, teamId!)
  );

  const lastRelease =
    teamSettings?.["distribution_videos_last_release" as keyof TeamSettings];

  const [value, setValue] = useState(lastRelease || "");

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "" || /^[0-9\b]+$/.test(e.target.value)) {
      setValue(e.target.value);
    }
  };

  const debouncedValue = useDebounce(value, 500);

  useDidUpdate(() => {
    if (debouncedValue === lastRelease) {
      return;
    }

    dispatch.teams.updateSettings({
      teamId: teamId!,
      updatedSettings: {
        distribution_videos_last_release: debouncedValue,
      },
    });
  }, [debouncedValue, teamId]);

  return (
    <InputGroup>
      <StyledText $type="smallBold" $color="black">
        Last release (days)
      </StyledText>
      <Wrapper>
        <ResetHolder>
          <ResetButton onClick={() => setValue("")}>reset</ResetButton>
        </ResetHolder>
        <StyledInput
          placeholder="Enter number"
          name="lastRelease"
          value={value}
          onChange={onChange}
        />
      </Wrapper>
    </InputGroup>
  );
};

export default DistributionVideoFilter;
